import { Pipe, PipeTransform } from '@angular/core';
import { CalendarTaskHeaderGroup } from '../model/calendar/calendar-task-header-group';

@Pipe({
  name: 'resourcePagination',
  standalone: true,
})
export class ResourcePaginationPipe implements PipeTransform {
  transform(
    groups: CalendarTaskHeaderGroup[],
    page: number,
    step: number,
  ): CalendarTaskHeaderGroup[] {
    const array = [];
    const start = page * step;
    const end = (page + 1) * step;
    let i = 0;
    for (const gr of groups) {
      const group = new CalendarTaskHeaderGroup(gr.id, gr.label);
      const totalTasksDuration = gr.totalTasksDuration;
      for (let j = 0; j < gr.tasksGroups.length && i < end; ++j) {
        if (i >= start && i < end) {
          group.tasksGroups.push(gr.tasksGroups[j]);
        }
        ++i;
      }
      if (group.tasksGroups.length > 0) {
        group.totalTasksDuration = totalTasksDuration;
        array.push(group);
      }
      if (i >= end) {
        break;
      }
    }
    return array;
  }
}
